/** Counts direct scene children, Minecraft scene objects, and live instance placements. */
export class SceneStats {

    objectCount: number = 0;
    sceneObjectCount: number = 0;
    instanceCount: number = 0;

}
